import { Result } from 'antd'

interface Props {
  description?: string
}

export default function AccessDeniedPage({ description }: Props) {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
      data-testid="access-denied"
    >
      <Result
        status="403"
        title="Access denied"
        subTitle={
          description ??
          'This console requires admin permissions. Sign in with an admin account.'
        }
      />
    </div>
  )
}
